import { createContext } from 'react';

const ModalStackContext = createContext();

export default ModalStackContext;
